import { Link, NavLink } from "react-router-dom";
import { Show, SignInButton, UserButton } from "@clerk/react";
import { Compass, UploadSimple, Sparkle, Heart, ChartLine } from "@phosphor-icons/react";
import { useProfile } from "@/context/ProfileContext";

export default function Header() {
  const { profile } = useProfile();
  const navItem = ({ isActive }) =>
    `font-mono-ui text-[11px] uppercase tracking-[0.25em] px-3 py-2 border-b-2 transition-colors ${
      isActive ? "border-red-600 text-white" : "border-transparent text-neutral-400 hover:text-white"
    }`;

  return (
    <header
      className="sticky top-0 z-40"
      style={{
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        background: "rgba(5,5,5,0.8)",
        borderBottom: "1px solid rgba(255,255,255,0.06)",
      }}
    >
      <div className="flex items-center gap-6 px-4 md:px-10 py-4">
        <Link to="/" data-testid="brand-link" className="flex items-baseline gap-2">
          <span className="font-display text-xl md:text-2xl font-black tracking-tighter whitespace-nowrap" data-testid="brand-name">STELLA CREATIVE MUSIC</span>
        </Link>

        <nav className="hidden md:flex items-center ml-6">
          <NavLink to="/" end className={navItem} data-testid="nav-discover">
            <Compass size={14} className="inline mr-1.5 -mt-0.5" /> Discover
          </NavLink>
          <NavLink to="/upload" className={navItem} data-testid="nav-upload">
            <UploadSimple size={14} className="inline mr-1.5 -mt-0.5" /> Release
          </NavLink>
          <NavLink to="/coach" className={navItem} data-testid="nav-coach">
            <Sparkle size={14} className="inline mr-1.5 -mt-0.5" /> AI Coach
          </NavLink>
          <NavLink to="/library" className={navItem} data-testid="nav-library">
            <Heart size={14} className="inline mr-1.5 -mt-0.5" /> Library
          </NavLink>
          <NavLink to="/studio" className={navItem} data-testid="nav-studio">
            <ChartLine size={14} className="inline mr-1.5 -mt-0.5" /> Studio
          </NavLink>
        </nav>

        <div className="ml-auto flex items-center gap-3">
          <Show when="signed-out">
            <SignInButton>
              <button
                className="font-mono-ui text-[11px] uppercase tracking-[0.25em] px-5 py-2 border border-neutral-700 hover:border-red-600 hover:text-red-500 transition-colors"
                data-testid="sign-in-btn"
              >
                Sign in
              </button>
            </SignInButton>
          </Show>
          <Show when="signed-in">
            {profile?.is_artist && (
              <Link to="/studio" data-testid="header-artist-link" className="hidden sm:flex items-center gap-2 max-w-[260px]">
                {profile.avatar_url && (
                  <img src={profile.avatar_url} alt="" data-testid="header-artist-photo"
                       className="w-7 h-7 rounded-full object-cover border border-neutral-700 shrink-0" />
                )}
                <span data-testid="header-artist-name"
                      className="font-mono-ui text-[11px] uppercase tracking-[0.2em] text-neutral-300 hover:text-white truncate">
                  {profile.display_name}
                </span>
              </Link>
            )}
            <UserButton />
          </Show>
        </div>
      </div>
    </header>
  );
}
